import { Request, Response, NextFunction } from 'express';
import JobService from '../services/job.service';
import Container from 'typedi';
import { jsonStatus, status } from '../../../utils/helpers/api.responses';
import { HttpException } from '../../../utils/exceptions/httpException';

export class JobController {
    public jobService = Container.get(JobService);

    public createJob = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { companyName, location, noOfSpots, note } = req.body;
            const t = req.t;
            const createdBy = req.user._id
            const job = await this.jobService.createJob({ companyName, location, noOfSpots, note, createdBy }, t);
            res.status(status.Create).json({
                status: jsonStatus.Create,
                message: t('General.create_success', { field: t('Job.job') }),
                data: job
            });
        } catch (error) {
            next(error);
        }
    };

    public getJobs = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const {
                page = 1,
                limit = 10,
                search = "",
                sortBy = "createdAt",
                sortOrder = "desc",
                Jobstatus,
                ...filters
            } = req.query;
            const parsedJobStatus = typeof Jobstatus === 'string' ? Jobstatus : undefined;

            const result = await this.jobService.getJobs({
                filters: { status: parsedJobStatus, ...filters },
                page: parseInt(page as string),
                limit: parseInt(limit as string),
                search: search as string,
                sortBy: sortBy as string,
                sortOrder: sortOrder as string,
                t,
            }); res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Job.jobs') }),
                data: result.data,
                total: result.total,
                totalPages: result.totalPages,
                page: result.page
            });
        } catch (error) {
            next(error);
        }
    };

    public getOpneJobs = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const {
                page = 1,
                limit = 10,
                search = "",
                sortBy = "createdAt",
                sortOrder = "desc",
                Jobstatus,
                ...filters
            } = req.query;
            const parsedJobStatus = typeof Jobstatus === 'string' ? Jobstatus : undefined;

            const result = await this.jobService.getOpenJobs({
                filters: { status: parsedJobStatus, ...filters },
                page: parseInt(page as string),
                limit: parseInt(limit as string),
                search: search as string,
                sortBy: sortBy as string,
                sortOrder: sortOrder as string,
                t,
            }); res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Job.jobs') }),
                data: result.data,
                total: result.total,
                totalPages: result.totalPages,
                page: result.page
            });
        } catch (error) {
            next(error);
        }
    };

    public getJobById = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const t = req.t;
            const job = await this.jobService.getJobById(id, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Job.job') }),
                data: job
            });
        } catch (error) {
            next(error);
        }
    };

    public updateJob = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const { companyName, location, noOfSpots, note } = req.body;
            const t = req.t;
            const job = await this.jobService.updateJob(id, { companyName, location, noOfSpots, note }, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.update_success', { field: t('Job.job') }),
                data: job
            });
        } catch (error) {
            next(error);
        }
    };

    public deleteJob = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { ids } = req.body;
            if (!Array.isArray(ids) || ids.length === 0) {
                throw new HttpException(status.BadRequest, req.t('General.required', { field: 'ids' }));
            }
            const t = req.t;
            const updatedBy = req.user._id
            await this.jobService.hardDeleteJob(ids, t, updatedBy);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.delete_success', { field: t('Job.job'), count: ids.length })
            });
        } catch (error) {
            next(error);
        }
    };

    public closeJob = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const t = req.t;
            const job = await this.jobService.closeJob(id, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.update_success', { field: t('Job.job') }),
                data: job
            });
        } catch (error) {
            next(error);
        }
    };
}